const REQUEST_KIND_ID = 'request'
const RELATIONSHIP_SELF_KIND_ID = 'relationship_self'
const RELATIONSHIP_TITULAR_KIND_ID = 'relationship_titular'
const DEMAND_KIND_ID = 'demand'
const CUSTOM_KIND_ID = 'custom'
const ATTACHMENT_KIND_ID = 'attachment'

export default {
  REQUEST_KIND_ID,
  RELATIONSHIP_SELF_KIND_ID,
  RELATIONSHIP_TITULAR_KIND_ID,
  DEMAND_KIND_ID,
  CUSTOM_KIND_ID,
  ATTACHMENT_KIND_ID,
}
